import { RootState } from '@/src/redux/store';
import { userState } from '@/src/redux/userSlice/userSlice';
import useParamsEditor from '@/src/utils/useParamsEditor';
import {
  useGetFavouritesQuery,
  useAddFavouriteMutation,
  useRemoveFavouriteMutation,
} from '@api/api';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { MdStarOutline, MdStar, MdOutlineRemoveCircle } from 'react-icons/md';
import { useSelector } from 'react-redux';

export default function Favourite({ adId }: { adId: number }) {
  const t = useTranslations('user.favourites');
  const editParam = useParamsEditor();
  const user: userState = useSelector((state: RootState) => {
    return state.user;
  });
  const { data: favourites, isFetching } = useGetFavouritesQuery(user.userId, {
    skip: !user.loggedIn,
  });
  const added = favourites?.data?.map((obj: any) => obj.id).includes(adId);
  const [addedTemporary, setAdded] = useState(false);
  const isAdded = isFetching ? addedTemporary : added;
  const [addFavourite, { isLoading: isAdding }] = useAddFavouriteMutation();
  const [removeFavourite, { isLoading: isRemoving }] =
    useRemoveFavouriteMutation();
  const openLogin = () => {
    editParam('modal', 'login');
  };
  const addToFavourite = () => {
    const payload = { userId: user.userId, adId };
    if (!added) {
      addFavourite(payload);
      setAdded(true);
    } else {
      removeFavourite(payload);
      setAdded(false);
    }
  };
  return (
    <span className='shrink'>
      {isAdded ? (
        <button
          className={`${
            isAdding || isRemoving ? 'opacity-50' : ''
          } mt-2 group flex items-center gap-2`}
          onClick={user.loggedIn ? addToFavourite : openLogin}
        >
          <span className='text-3xl text-[gold]'>
            <MdStar className='block group-hover:hidden' />
            <MdOutlineRemoveCircle className='hidden group-hover:block' />
            {/* change icon to minus or something*/}
          </span>
          {t('removeFromFavourites')}
        </button>
      ) : (
        <button
          className={`${
            isAdding || isRemoving ? 'opacity-50' : ''
          } mt-2 group flex items-center gap-2`}
          onClick={user.loggedIn ? addToFavourite : openLogin}
        >
          <span className='text-3xl text-[gold]'>
            <MdStar className='hidden group-hover:block' />
            <MdStarOutline className='block group-hover:hidden' />
          </span>
          {t('addToFavourites')}
        </button>
      )}
    </span>
  );
}
